import ChildrenCategoriesTypeEnum from 'Rentlio/utils/childrenCategoriesEnum'
import { childrenCategoryDerivationType } from 'Rentlio/utils/childrenCategoryDerivationType'

/** Total value for all nights **/
const getOBPChildrenPrice = (categories, priceForAdult, nights) => {
  if (!categories || categories.length === 0) {
    return 0
  }
  let priceForChildren = 0

  categories.map(category => {
    switch (category.type) {
      case ChildrenCategoriesTypeEnum.AS_ADULT:
        break
      case ChildrenCategoriesTypeEnum.CUSTOM: {
        if (!category.percentageValue && !category.nominalValue) {
          break
        }
        const priceForChild =
          category.valueType === childrenCategoryDerivationType.PERCENTAGE
            ? (+category.percentageValue / 100) * priceForAdult
            : +category.nominalValue * nights
        priceForChildren += priceForChild
        break
      }

      case ChildrenCategoriesTypeEnum.MANUAL:
        priceForChildren += category.nominalValue * nights
        break
    }
  })

  return priceForChildren
}

export default getOBPChildrenPrice
